import { PinnedStatusManager } from './pinned-status-manager';

// There should really ever only be one of these per tab, so just create a singleton instance and export that
export const pinnedStatusManager = new PinnedStatusManager();
